<template>
    <div>
        <b-tabs v-model="activeTab" class="chart-config-tabs">
            <b-tab
                v-for="(cfg, i) in value"
                :key="i"
                :title="`Graphique ${i + 1}`">
                <div class="pt-2">
                    <chart-config-form :value="cfg" :columns="columns" :table-structure="tableStructure" :context="context" @input="update(i, $event)" />
                    <div class="mt-2 text-right">
                        <b-button v-show="value.length > 1" size="sm" variant="outline-danger" @click="remove(i)">
                            <i class="fas fa-trash-alt"></i> Supprimer
                        </b-button>
                    </div>
                </div>
            </b-tab>
            <template #tabs-end>
                <b-nav-item @click.prevent="add" class="ml-1" title="Ajouter un graphique">
                    <i class="fas fa-plus"></i>
                </b-nav-item>
            </template>
        </b-tabs>
    </div>
</template>

<script>
import ChartConfigForm, { defaultChartConfig } from './ChartConfigForm.vue';
export { defaultChartConfig };

export default {
    name: 'ChartConfig',
    components: { ChartConfigForm },
    props: {
        value:          { type: Array,  required: true },
        columns:        { type: Array,  default: () => [] },
        tableStructure: { type: Array,  default: null },
        context:        { type: String, default: null }
    },
    data() {
        return { activeTab: 0 };
    },
    methods: {
        add() {
            const newArr = [...this.value, defaultChartConfig()];
            this.$emit('input', newArr);
            this.$nextTick(() => { this.activeTab = newArr.length - 1; });
        },
        remove(i) {
            const newArr = this.value.filter((_, j) => j !== i);
            this.$emit('input', newArr);
            this.$nextTick(() => {
                if (this.activeTab >= newArr.length) this.activeTab = newArr.length - 1;
            });
        },
        update(i, cfg) {
            const arr = [...this.value];
            arr[i] = cfg;
            this.$emit('input', arr);
        }
    }
};
</script>

<style scoped>
.chart-config-tabs {
    margin-top: 8px;
}
</style>
